import { useEffect, useState } from 'react';

import { PopUpWindow } from './WindowManager';
import styled from 'styled-components';

export function WindowBackdrop() {
  const [windowOpen, setWindowOpen] = useState(false);

  useEffect(() => {
    PopUpWindow.on('open', () => {
      setWindowOpen(true);
    });

    PopUpWindow.on('close', () => {
      setWindowOpen(false);
    });
  }, []);

  if (windowOpen) {
    return (
      <Backdrop
        data-testid="popup-window-backdrop"
        onClick={() => PopUpWindow.focus()}
      />
    );
  }

  return null;
}

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;
